<template>
  <div>
    <b-alert
      show
      variant="light"
      class="alert alert-custom alert-white alert-shadow fade show gutter-b"
    >
      <div class="alert-icon">
        <span class="svg-icon svg-icon-lg">
          <inline-svg src="/media/svg/icons/Tools/Compass.svg" />
        </span>
      </div>
      <div class="alert-text"><b>Setelan</b> website Klinik Hayandra</div>
      <b-button
        squared
        variant="success"
        @click="btnAddOnClick()"
        >Tambah</b-button
      >
    </b-alert>

    <div class="row">
      <div class="col-md-12">
        <Card>
          <template v-slot:body>
            <Table purpose="master" />
          </template>
        </Card>
      </div>
    </div>

    <b-card no-body class="overflow-hidden form-setting">
      <b-row no-gutters>
        <b-col md="6">
          <b-card-img
            src="/images/website-klinik-hayandra.png"
            class="rounded-0 mt-10"
          ></b-card-img>
        </b-col>
        <b-col md="6">
          <Form :form="form" :route="'website-settings'" v-if="FormEditActv == false && FormDetailActv == false" />
          <FormEdit :form="form" :route="'website-settings/' + form.id" v-if="FormEditActv == true" />
          <FormDetail :form="form" :route="'website-settings/' + form.id" v-if="FormDetailActv == true" />
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import Card from "@/view/content/Card.vue";
import Table from "@/component/websites/SettingTable.vue";
import Form from "@/component/websites/SettingForm.vue";
import FormEdit from "@/component/websites/SettingFormEdit.vue";
import FormDetail from "@/component/websites/SettingFormDetail.vue";
import CrudModule from "@/core/modules/CrudModule.js";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";

export default {
  name: "website-setting",
  data() {
    return {
      form: {
        title: "",
        address: "",
        phone: "",
        emergency: "",
        support: "",
        email: "",
        text_1: "",
        text_2: "",
        text_3: "",
        facebook_id: "",
        twitter_id: "",
        instagram_id: "",
        youtube_id: "",
        linkedin_id: "",
        status: 0,
        logo: [],
      },
    FormEditActv: false,
    FormDetailActv: false,
    };
  },
  components: {
    Card,
    Table,
    Form,
    FormEdit,
    FormDetail,
    CrudModule,
  },
  methods: {
    resetFormOnNew(){
      // reset form on new (tambah data)
      var self = this;
      Object.keys(this.form).forEach(function (key, index) {
        if (key === "logo") {
          self.form[key] = [];
        } else {
          self.form[key] = "";
        }
      });
    },

    scrollToElement(options) {
      let el = this.$el.getElementsByClassName("pagination")[0];
      el = el ?? this.$el.getElementsByClassName("table-setting")[0];
      if (el) {
        el.scrollIntoView(options);
        // reset form on new (tambah data)
        this.resetFormOnNew()
      }
    },

    scrollToTop(options) {
       let el = this.$el.getElementsByClassName("alert")[0];
       let er = this.$el.getElementsByClassName("alert");
      // el = el ?? this.$el.getElementsByClassName("table-setting")[0];
      console.log("el", el)
      console.log("er", er)
      if (el) {
        el.scrollIntoView(options);
        // reset form on new (tambah data)
        this.resetFormOnNew()
      }
    },

    btnAddOnClick(){
      this.scrollToElement({ behavior: 'smooth' })
      this.FormEditActv = false
      this.FormDetailActv = false
    },
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Website", route: "" },
      { title: "Setelan", route: "" },
    ]);

    // Add Website Setting
    this.$root.$on("updateWebsiteSetting", () => {
      // reset form on new (tambah data)
      this.resetFormOnNew()
      this.scrollToTop({ behavior: 'smooth' });
    });

    // Edit Website Setting
    this.$root.$on("getWebsiteSettingById", (data) => {
      this.FormEditActv = true
      this.FormDetailActv = false
     this.scrollToElement({ behavior: 'smooth' })
      console.log("data", data)

      if(data.status == 0){
        data.status = false
      }else if(data.status == 1){
        data.status = true
      }

     this.form = data
     this.form['_method'] = 'put'
    });

    // Cancel Edit
    this.$root.$on("cancelWebsiteSettingUpdate", () => {
      this.FormEditActv = false
      this.scrollToTop({ behavior: 'smooth' })
      this.resetFormOnNew()
    });

    // Detail Web Setting
    this.$root.$on("getWebsiteSettingByIdDetail", (data) => {
      this.FormDetailActv = true
      this.FormEditActv = false
     this.scrollToElement({ behavior: 'smooth' })
      console.log("data", data)
      if(data.status == 0){
        data.status = false
      }else if(data.status == 1){
        data.status = true
      }
     this.form = data
    });

      // Close Detail
    this.$root.$on("closeWebsiteSettingDetail", () => {
      this.FormDetailActv = false
      this.scrollToTop({ behavior: 'smooth' })
      this.resetFormOnNew()
    });
    
  },
};
</script>
